const Modal = ({ children, onClose }) => {
    return (
        <div style={{
            position: "fixed",
            top: 0, left: 0,
            width: "100%", height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1001
        }}>
            <div style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "500px",
                width: "90%"
            }}>
                {children}
                {/* <button
                    onClick={onClose}
                    style={{
                        backgroundColor: "#f44336",   // 🔴 Red color
                        color: "#fff",                // ✅ White text
                        padding: "10px 20px",         // ✅ Comfortable padding
                        border: "none",               // ✅ Remove default border
                        borderRadius: "8px",          // ✅ Rounded corners
                        cursor: "pointer",            // ✅ Pointer on hover
                        fontSize: "14px",             // ✅ Clean font size
                        fontWeight: "bold",           // ✅ Bold text
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // ✅ Subtle shadow
                        transition: "all 0.3s ease",  // ✅ Smooth hover effect
                        marginTop: "10px",            // ✅ Keep spacing
                        marginLeft: "10px"            // ✅ Add spacing if next to another button
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#d32f2f")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "#f44336")}
                >
                    Close
                </button> */}

            </div>
        </div>
    );
};

export default Modal;
